import { axiosInstance } from '../axios';

export const fetchDashboardData = () => {
  return axiosInstance.get('/api/dashboard/');
};
